import { Check } from "lucide-react";

export default function ServiceCard({ service, selected, onToggle }) {
  return (
    <button
      type="button"
      onClick={() => onToggle(service.id)}
      data-testid={`service-card-${service.id}`}
      className={[
        "group relative text-left p-5 transition-all duration-300 ease-out",
        "border bg-white",
        selected
          ? "border-champagne-500 bg-champagne-50/70"
          : "border-zinc-200 hover:border-charcoal-900/40",
      ].join(" ")}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-serif text-xl text-charcoal-900 leading-tight">
            {service.label}
          </div>
          <div className="mt-1 text-sm text-charcoal-500 leading-snug">
            {service.blurb}
          </div>
        </div>
        <div
          className={[
            "flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors",
            selected
              ? "border-champagne-500 bg-champagne-500 text-white"
              : "border-zinc-300 text-transparent group-hover:border-charcoal-900/50",
          ].join(" ")}
          aria-hidden
        >
          <Check size={14} strokeWidth={2} />
        </div>
      </div>
    </button>
  );
}
